import PropTypes from 'prop-types';
import { useMemo, createContext } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import shape from './shape';
import palette from './palette';
import paletteDark from './paletteDark';

import typography from './typography';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';
import usePersistedState from '../common/utils/usePersistedState';

// ----------------------------------------------------------------------
export const ColorModeContext = createContext({ mode: 'light', toggleColorMode: () => {} });

const getDefaultMode = 'light';
// ----------------------------------------------------------------------
ThemeConfig.propTypes = {
  children: PropTypes.node
};

export default function ThemeConfig({ children }) {
  const [mode, setMode] = usePersistedState('mode', getDefaultMode);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      }
    }),
    [mode, setMode]
  );

  const themeOptions = useMemo(
    () => ({
      palette:
        mode === 'dark'
          ? {
              ...paletteDark,
              mode,
              background: { default: '#1B262C', paper: '#1B262C' }
            }
          : {
              ...palette,
              mode,
              background: { default: '#fff', paper: '#fff' }
            },
      shape,
      typography,
      shadows,
      customShadows
    }),
    [mode]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {children}
        </ThemeProvider>
      </StyledEngineProvider>
    </ColorModeContext.Provider>
  );
}
